export function capitalizeFirstLetters(str: string | undefined): string {
    if (str === undefined) {
        return "";
    }

    return str
        .toLowerCase() // Convert the string to lowercase
        .split(' ') // Split the string into words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(' '); // Join the words back into a string
}
